module.exports = __webpack_public_path__ + "static/img/bg-pt.a8578ae1.png";